module.exports = __webpack_public_path__ + "media/base/builder_tool_modal-9bda3b51.png";